import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[120px] w-full rounded-none border-2 border-ink bg-off px-3 py-2 text-base text-ink placeholder:text-ink/50 focus-visible:outline-none focus-visible:border-purple focus-visible:ring-2 focus-visible:ring-purple/30 disabled:cursor-not-allowed disabled:opacity-60",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
